import { render, staticRenderFns } from "./ProductDevicesDataTable.vue?vue&type=template&id=54f299ac"
import script from "./ProductDevicesDataTable.vue?vue&type=script&lang=ts"
export * from "./ProductDevicesDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports